<template>
    <div class="py-4">
        <div class="row" v-if="currentUserInfo.is_paid_seat">
            <div class="col">
                <!-- KPI TREE HERE -->
                <kpi-tree-x-6></kpi-tree-x-6>
                <div class="my-5 text-center" v-if="loading" key="loading">
                    <h6 class="text-muted">Loading...</h6>
                </div>
                <b-tabs 
                    v-else-if="hasSystems"
                    key="systemsTabs"
                    no-nav-style 
                    nav-class="spl-floating-nav" 
                    nav-wrapper-class="d-flex"
                    content-class="mt-3"
                    lazy
                >
                    <b-tab title="TOTAL SCORE" active>
                        <!-- <h4>Summary</h4> -->
                        <scorecard-vendor-summary
                            key="summary_scorecard_system"
                            system-id="summary"
                            :vendor-id="resource.id"
                            descending
                            hide-details
                            class="my-4 bg-gray-200 border rounded-lg px-4 py-3"
                        ></scorecard-vendor-summary>
                    </b-tab>
                    <b-tab
                        v-for="scs in scorecardSystems"
                        :key="scs.id"
                        :title="scs.name"
                    >
                        <scorecard-vendor-summary
                            :key="scs.id"
                            :system-id="scs.id"
                            :vendor-id="resource.id"
                            descending
                            class="my-4 bg-gray-200 border rounded-lg px-4 py-3"
                        ></scorecard-vendor-summary>
                    </b-tab>
                </b-tabs>
                <div class="my-5 text-center" v-else key="noSystems">
                    <h6>No scorecards or KPIs to show</h6>
                </div>
            </div>
        </div>
        <div
            v-else
            class="my-5 w-100 min-height-150 d-flex justify-content-center align-items-center"
        >
            <div class="font-weight-bold text-muted font-size-100">
                Scorecards are not available based on your permissions.
            </div>
        </div>
    </div>
</template>

<script>
import { suppliosApi } from '../../../js/api-service';
import { errorHandling, currentUserInfoMixin } from "../../../js/custom-vue-mixins";

export default {
    props: ["resource"],
    mixins: [errorHandling, currentUserInfoMixin],
    data() {
        return {
            loading: false,
            scorecardSystems: [],  // all scorecard systems 
            selectedKey: 'summary',
        }
    },
    computed: {
        hasSystems() {
            return !!this.scorecardSystems?.length;
        },
        systemsById() {
            return Object.fromEntries(this.scorecardSystems.map(scs => ([scs.id, scs])));
        },
        systemIds() {
            return this.scorecardSystems.map(scs => scs.id);
        },
    },
    mounted() {
        this.getScorecardSystems();
    },
    methods: {
        async getScorecardSystems() {
            this.loading = true;
            let resp;
            try {
                resp = await suppliosApi.scorecardSystem.list_systems_for_vendor(this.resource.id);
            } catch (error) {
                this.apiErrorHandler(error);
            }
            if (resp?.data) {
                this.scorecardSystems = resp.data;
            }
            this.loading = false;
        },
        handleSelection(systemIdOrKey) {
            this.selectedKey = systemIdOrKey;
        },
    },
};
</script>
